import { apiClient } from './api';
import {
  User,
  UserFormData,
  UsersResponse,
  UserResponse
} from '../types';

class UserApiService {
  async getUsers(params: {
    page?: number;
    limit?: number;
    search?: string;
    roleId?: number;
    isActive?: boolean;
    sortBy?: string;
    sortOrder?: string;
  } = {}): Promise<UsersResponse> {
    const queryParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, value.toString());
      }
    });

    const queryString = queryParams.toString();
    const endpoint = `/users${queryString ? `?${queryString}` : ''}`;

    const response = await apiClient.get<{ users: User[]; pagination: { page: number; limit: number; total: number; totalPages: number } }>(endpoint);
    return response as unknown as UsersResponse;
  }

  async getUserById(id: number): Promise<UserResponse> {
    const response = await apiClient.get<User>(`/users/${id}`);
    return response as unknown as UserResponse;
  }

  async createUser(userData: UserFormData): Promise<UserResponse> {
    const response = await apiClient.post<User>('/users', userData);
    return response as unknown as UserResponse;
  }

  async updateUser(id: number, userData: Partial<UserFormData>): Promise<UserResponse> {
    const response = await apiClient.put<User>(`/users/${id}`, userData);
    return response as unknown as UserResponse;
  }

  async deleteUser(id: number): Promise<{ success: boolean; message: string }> {
    const response = await apiClient.delete<{ success: boolean; message?: string }>(`/users/${id}`);
    return {
      success: response.success,
      message: response.message || 'User deleted successfully.',
    };
  }

  async activateUser(id: number): Promise<UserResponse> {
    const response = await apiClient.put<User>(`/users/${id}/activate`);
    return response as unknown as UserResponse;
  }

  async deactivateUser(id: number): Promise<UserResponse> {
    const response = await apiClient.put<User>(`/users/${id}/deactivate`);
    return response as unknown as UserResponse;
  }

  async resetUserPassword(id: number): Promise<{
    success: boolean;
    data: { tempPassword: string };
    message: string;
  }> {
    const response = await apiClient.post<{ tempPassword: string }>(`/users/${id}/reset-password`);
    return {
      success: response.success,
      data: response.data,
      message: response.message || 'Password reset successfully.',
    };
  }
}

export const userApi = new UserApiService();
